import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cross\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.6667 4.26665L11.7333 3.33331L8.00001 7.06665L4.26668 3.33331L3.33334 4.26665L7.06668 7.99998L3.33334 11.7333L4.26668 12.6666L8.00001 8.93331L11.7333 12.6666L12.6667 11.7333L8.93334 7.99998L12.6667 4.26665Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol